import React, { Component } from "react";
import CheckDefecto from "../../../../../Common/Components/CheckDefecto"
import ExpHelper from '../../../../../Common/Helpers/ExpHelper';

export default class FactorLimiteCompraCuotas extends Component {
    constructor(props) {
        super(props);

        this.state = {
            FLCCDesde: props.data.FLCCDesde,
            FLCCHasta: props.data.FLCCHasta,
            FLCCDefault: props.data.FLCCDefault
        };
    }

    onFactorLimiteCompraChange(event) {
        const { value, dataset } = event.target;
        const regExp = new RegExp(dataset.validation);

        /*Antes de actualizar cualquier cosa, valido que se haya presionado el boton*/
        if (this.props.data.FLCCxCuenta) {
            if ((regExp.test(value) || value.replace(/\s/g, "", "") == "") && value<9.1) {
                let newState = {
                    [dataset.code]: value
                }

                if (dataset.code == "FLCCDesde") {
                    newState = {
                        ...newState,
                        FLCCDefault: value
                    }
                }

                this.setState(newState);
            }
        }
    }

    onFactorLimiteCompraBlur(event) {
        const { value, dataset } = event.target;
            this.props.changeInput(dataset.code, value);
    }

    componentWillReceiveProps(nextProps) {

        if (nextProps.data.FLCCxCuenta == false) {
            nextProps.data.FLCCDesde = nextProps.data.FLCCHasta = nextProps.data.FLCCDefault = "";
        }

        this.setState({
            FLCCDesde: nextProps.data.FLCCDesde,
            FLCCHasta: nextProps.data.FLCCHasta,
            FLCCDefault: nextProps.data.FLCCDefault
        });
    }

    render() {
        const { onFactorLimiteCompraChange, onFactorLimiteCompraBlur } = this;
        const { data, selectCheckBox } = this.props;
        let acentoLetraIminuscula = ExpHelper.ConvertirCaracter("i");
        let limitesErroneos, limiteDefaultErroneo = false

        if(this.state.FLCCHasta && this.state.FLCCDesde>this.state.FLCCHasta){
            limitesErroneos = true
        }
        if(this.state.FLCCHasta && !limitesErroneos && this.state.FLCCDefault ){
            if(!(this.state.FLCCDefault >= this.state.FLCCDesde) || !(this.state.FLCCDefault <= this.state.FLCCHasta)){
                limiteDefaultErroneo = true
            } 
        }

        if(!data.GET_PARAMETRO_GENERAL.SINOFACTORLIMITECOMPRACUOTA){
            return null
        }

        return (
            <div>
                <div className="row top-separator-xs">
                    <div className="col-xs-12">
                        <label className="label-primary">{"Factor de límite de compra en cuotas (FLCC)"}</label>
                        <CheckDefecto
                            nombre={"Establecer Por Cuenta"}
                            check={data.FLCCxCuenta}
                            referencia={"FACLIMCOMCUO"}
                            selectCheckBox={(event) => selectCheckBox("FLCCxCuenta", event.target.checked)}
                        />
                        <div className="container-radio radio-margin">
                            <div className="row">
                                <div className="col-xs-3">
                                    <label className="lbl-radio label-secondary">{"Rango de Coeficiente"}</label>
                                </div>

                                <div className="col-xs-3">
                                    <input className="form-control input-Short"
                                        maxLength={3}
                                        value={this.state.FLCCDesde}
                                        data-code="FLCCDesde"
                                        data-validation="^(?=.*[0-9])\d{0,2}(?:\.\d{0,1})?$"
                                        disabled={!data.FLCCxCuenta}
                                        onChange={onFactorLimiteCompraChange.bind(this)}
                                        onBlur={onFactorLimiteCompraBlur.bind(this)}
                                    />
                                </div>

                                <div className="col-xs-1">
                                    <label className="label-secondary">{" a"}</label>
                                </div>

                                <div className="col-xs-3">
                                    <input className="form-control input-Short"
                                        maxLength={3}
                                        value={this.state.FLCCHasta}
                                        data-code="FLCCHasta"
                                        data-validation="^(?=.*[0-9])\d{0,2}(?:\.\d{0,1})?$"
                                        disabled={!data.FLCCxCuenta}
                                        onChange={onFactorLimiteCompraChange.bind(this)}
                                        onBlur={onFactorLimiteCompraBlur.bind(this)}
                                    />
                                </div>
                                <div className="col-xs-1"><label></label></div>
                            </div>

                            <div className="row">
                                <div className="col-xs-3">
                                    <label className="lbl-radio label-secondary">{"Coeficiente exacto por defecto"}</label>
                                </div>

                                <div className="col-xs-3">
                                    <input className="form-control input-Short"
                                        maxLength={3}
                                        value={this.state.FLCCDefault}
                                        data-code="FLCCDefault"
                                        data-validation="^(?=.*[0-9])\d{0,2}(?:\.\d{0,1})?$"
                                        disabled={!data.FLCCxCuenta}
                                        onChange={onFactorLimiteCompraChange.bind(this)}
                                        onBlur={onFactorLimiteCompraBlur.bind(this)}
                                    />
                                </div>
                            </div>
                            {data.FLCCxCuenta && <div className="lbl-radio">
                            <CheckDefecto
                                
                                check={data.FLCCDefaultInterfaz}
                                referencia={"FACLIMCOMCUODEF"}
                                selectCheckBox={(event) => selectCheckBox("FLCCDefaultInterfaz", event.target.checked)}
                                />
                            </div>}
                        </div>
                        
                    {(this.props.data.ERROR_PRODUCT["seleccionoFactorLimiteCompra"] == false && !limitesErroneos && (!this.state.FLCCHasta || !this.state.FLCCDesde ) && data.FLCCxCuenta )
                        && <label className="error">{"Debe ingresar el factor de límite de compra"}</label>}
                    {(limitesErroneos )
                        && <label className="error">{"El límite inferior debe ser menor o igual al límite superior"}</label>}
                    {(limiteDefaultErroneo )
                        && <label className="error">{"El valor por defecto debe estar entre el límite inferior y superior"}</label>}
                    </div>
                </div>
            </div>
        );
    }
}